import {post, get} from '@/request/request'
import {
  ILoginResponse,
  IBaseRespone,
} from 'types/api'
import {
  IGetImageVerifyResponse, 
  TenantSecurityConfig,
	IPlatformRiskKeyRseponse,
} from 'types/api';
import { RegisterFrom } from "@/constant";

/* 短信登录 */
export function sendSmsForLogin(
  params: {
    mobile: string,
		clientType: string,
		captchaId?: string
  }) {
    return post<IBaseRespone<string>>('/open/tm/unified-login/v5/login/sendSmsForLogin', params)
}

/*
export function checkPhoneMultiAccountApi(
  params: {
    contextToken: string,
    deviceSource: string,
    mobile: string,
    redirectUrl: string,
    eid?: string,
    vpid?: string,
  }, timeout: number) {
    return post<IBaseRespone<ILoginMerchantCheckRseponse>>('/api/tm/unified-login/v2/open/login/mobile-verify', params, {
      timeout:timeout
    })
}

export function checkPasswordApi(
  params: {
    contextToken: string,
    password: string,
  }, timeout: number) {
    return post<IBaseRespone<ILoginMerchantCheckRseponse>>('/api/tm/unified-login/v2/open/login/password-verify', params, {
      timeout:timeout
    })
}

export function checkMoblieVerifyCodeApi(
  params: {
    contextToken: string,
    code: string,
    corpId?: string
    thirdUserId?: string
    tbAti?: string
    qrCodeSource?: string // WX_WORK , DING_DING , WX
  }, timeout: number) {
    return post<IBaseRespone<ILoginMerchantCheckRseponse>>('/api/tm/unified-login/v2/open/login/code-verify', params, {
      timeout:timeout
    })
}*/

// 根据tenantId取平台(用于风控)
export function getPlatformRiskKeysByTenant(
  params: {
    tenantId: string
}) {
  return post<IBaseRespone<IPlatformRiskKeyRseponse>>('/open/tm/unified-login/v5/login/getPlatformRiskKeysByTenant', params)
}

// 根据手机号取平台(用于风控)
export function getPlatformRiskKeysByMobile(
  params: {
    mobile: string
}) {
  return post<IBaseRespone<IPlatformRiskKeyRseponse>>('/open/tm/unified-login/v5/login/getRiskKeysByMobile', params)
}

// XXX
/**
 * 校验merchantId
 */
// export function checkMerchantId(
//   params: {
//     contextToken: string,
//     deviceSource: string,
//     registersource: string,
//     merchantId: string,
//     eid?: string,
//     vpid?: string,
//     redirectUrl: string
//     subRegisterSource: string
// }, timeout: number) {
//   return post<IBaseRespone<ILoginMerchantCheckRseponse>>('/api/tm/unified-login/v2/open/login/verify/merchantId', params, {
//     timeout:timeout
//   })
// }

/**
 * 校验账号密码是否正确，正确则返回成功
 */
export function loginByPassword(params:{
  mobileAccount: boolean,
  account: string
  password: string
  deviceId: string
	clientType: string,
	tenantId?: string
	captchaId?: string
    oauthBindKey?: string
	authCode?: string
	authKey?: string
	eid?: string,
	vid?: string
}) {
  return post<IBaseRespone<ILoginResponse>>('/open/tm/unified-login/v5/login/password', params)
}

// 短信验证码登录
export function loginBySms(params:{
  authKey: string,
  authCode: string
  oauthBindKey: string
  deviceId: string
	clientType: string,
  tenantId?: string
  eid?: string,
  vid?: string
}) {
  return post<IBaseRespone<ILoginResponse>>('/open/tm/unified-login/v5/login/submit', params)
}

// 获取安全监控数据
export function getTenantSecurityConfig() {
  return post<IBaseRespone<TenantSecurityConfig>>('/api/tm/unified-login/v5/admin/security/getConfig', {});
}

export function setTenantSecurityConfig(params: TenantSecurityConfig) {
  return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/security/setConfig', params);
}

//多账户选择登录
export function smsLoginGetToken(params:{
  authKey: string,
  tenantId: string,
  oauthBindKey?: string,
  eid?: string,
  vid?: string
}) {
  return post<IBaseRespone<ILoginResponse>>('/open/tm/unified-login/v5/login/smsLoginGetToken', params)
}


// 黑白名单设置
// export function ipListSetting(params: {
//   currentMerchantId:string
//   currentNickName:string
//   ips: string[]
//   attribute: number
//   status: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/auth/tenant/add/ipRule', params, {
//     timeout: timeout
//   })
// }

// 获取风险列表
// export function staffRiskList(params: {
//   currentMerchantId:string
//   currentNickName:string
//   pageSize: number,
//   pageNum: number
//   riskLevel: string,
//   beginTime: string,
//   endTime: string
// }, timeout: number) {
//   return post<IBaseRespone<RiskListData>>('/api/tm/unified-login/v2/auth/tenant/risk/page', params , {
//     timeout: timeout
//   })
// }

// 获取ip黑白名单列表
// export function getStaffIPListInfo(params: {
//   currentMerchantId:string
//   currentNickName:string
//   pageSize: number,
//   pageNum: number
//   attribute: number,
//   keyword: string,
//   beginTime: string,
//   endTime: string
// }, timeout: number) {
//   return post<IBaseRespone<IPOperationData>>('/api/tm/unified-login/v2/auth/tenant/ipRule/page', params, {
//     timeout: timeout
//   })
// }

// 获取员工白名单数据
// export function getStaffWhiteListInfo(params: {
//   currentMerchantId:string
//   currentNickName:string
//   pageSize: number,
//   pageNum: number
//   keyword: string,
//   beginTime: string,
//   endTime: string
// }, timeout: number) {
//   return post<IBaseRespone<IPOperationData>>('/api/tm/unified-login/v2/auth/tenant/employee/whiteList', params, {
//     timeout: timeout
//   })
// }

// 获取当前租户下所有的员工列表
// export function getAllStaffList(params: {
//   currentMerchantId:string
//   currentNickName:string
//   keyword: string,
// }, timeout: number) {
//   return post<IBaseRespone<SearchWhiteStaffList>>('/api/tm/unified-login/v1/auth/employee/search', params, {
//     timeout: timeout
//   })
// }

// 获取登录日志
// export function getLoginRecord(params: {
//   currentMerchantId:string
//   currentNickName:string
//   pageSize: number,
//   pageNum: number
//   keyword: string,
//   beginTime: string,
//   endTime: string
// }, timeout: number) {
//   return post<IBaseRespone<LoginLogData>>('/api/tm/unified-login/v2/auth/tenant/loginRecord/page', params, {
//     timeout: timeout
//   })
// }

// 获取安全/员工操作日志
// export function getOperationLog(params: {
//   currentMerchantId:string
//   currentNickName:string
//   pageSize: number,
//   pageNum: number,
//   keyword: string,
//   beginTime: string,
//   endTime: string,
//   model: string
// }, timeout: number) {
//   return post<IBaseRespone<OperationLogData>>('/api/tm/unified-login/v2/auth/tenant/operateRecord/page', params, {
//     timeout: timeout
//   })
// }

// 更新员工是否停用
// export function staffStatusUpdate(params: {
//   currentMerchantId:string
//   currentNickName:string
//   nickName: string,
//   status: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v1/auth/employeeStatus/update', params, {
//     timeout: timeout
//   })
// }

// 删除ip黑白名单员工
// export function deletBlackWhiteList(params: {
//   currentMerchantId:string
//   currentNickName:string
//   ips: string[],
//   attribute: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/auth/tenant/ipRule/delete', params, {
//     timeout: timeout
//   })
// }

// 定期修改密码
// export function modifyPasswordRegularly(params: {
//   currentMerchantId:string
//   currentNickName:string
//   modifyPasswordRegularly: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/auth/tenant/modifyPasswordRegularly/update', params, {
//     timeout: timeout
//   })
// }

// 登录页面强制弹出修改密码
export function loginForceModifyPassword(params: {
  captchaId: string
  newPassword: string
}) {
  return post<IBaseRespone<object>>('/open/tm/unified-login/v5/login/updatePassword', params)
}

// 定期登录限制
// export function loginLimit(params: {
//   currentMerchantId:string
//   currentNickName:string
//   loginLimit: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/auth/tenant/loginLimit/update', params, {
//     timeout: timeout
//   })
// }

// 员工白名单操作
// export function staffWhiteListModify(params: {
//   currentMerchantId:string
//   currentNickName:string
//   nickName: string[],
//   attribute: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v1/auth/employeeAttribute/update', params, {
//     timeout: timeout
//   })
// }


// 更新员工是否停用
// export function staffJurisdictionUpdate(params: {
//   currentMerchantId:string
//   currentNickName:string
//   nickName: string,
//   jurisdiction: number
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v1/auth/employeeJurisdiction/update', params, {
//     timeout: timeout
//   })
// }

// 更改ip规则
// export function updateIPRule(params: {
//   currentMerchantId:string
//   currentNickName:string
//   attribute: number,
//   sourceIp: string,
//   status: number,
//   targetIps: string[]
// }, timeout: number) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/auth/tenant/ipRule/update', params, {
//     timeout: timeout
//   })
// }

/**
 * TODO: 没有调用过
 * （慧策校验）校验手机验证码
 */
//  export function SMSVerifyCode(params:{
//    // 手机验证码
//   code: string,
//   contextToken: string
// }) {
//   return post<IBaseRespone<object>>('/api/tm/unified-login/v2/open/login/verify/loginInfo', params)
// }

// export function login(
//   params: {
//   username: string
//   password: string
//   merchantId: string
//   productName: string
//   ttl?: number
//   vc?: string
//   eid: string
//   vpid: string
// },timeout: number) {
//   return post<IBaseRespone<ILoginResponse>>('/api/tm/unified-login/v1/open/login', params,{
//     timeout: timeout
//   })
// }

/**
 * 退出登录接口
 */
export function signOut() {
  return post<IBaseRespone<object>>('/open/tm/unified-login/v5/login/logout', {})
}

/**
 * 获取图片验证码 V1
 */
export function  getImageVerifyCode(params: {
	captchaId: string
}) {
  return post<IBaseRespone<IGetImageVerifyResponse>>('/open/tm/unified-login/v5/common/captcha/generate', 
		params)
}

/**
 * 验证图片验证码 V1
 */
export function checkImageVerifyCode(params: {
  captchaId: string,
	authCode: string
}) {
  return post<IBaseRespone<void>>('/open/tm/unified-login/v5/common/captcha/verify', params)
}

/**
 * 校验账号安全  V2
 */
// export function checkSafeInfo(params: {
//   contextToken: string
// }, timeout:number) {
//   return post<IBaseRespone<CheckInfoMobileResponse>>('/api/tm/unified-login/v2/open/login/verify/safeInfo', params, {
//     timeout:timeout
//   })
// }

/**
 * 拿到token跳转登录  V2
*/
//  export function getToken(params: {
//   contextToken: string
// }, timeout:number) {
//   return post<IBaseRespone<GetTokenResponse>>('/api/tm/unified-login/v2/open/login/getToken', params, {
//     timeout:timeout
//   })
// }

/**
 * 登录慧策风控发送接口 V2
 */
 export function sendSmsForContinueLogin(params: {
  captchaId: string,
}) {
  return post<IBaseRespone<string>>('/open/tm/unified-login/v5/login/sendSmsForContinue', params)
}

/**
 * 登录慧策风控校验接口 V2
 */
export function verifySmsForContinueLogin(
  params: {
    authKey: string,
    authCode: string
  }
) {
  return post<IBaseRespone<void>>('/open/tm/unified-login/v5/login/verifySmsForContinue', params)
}

/**
 *  平台风控发送校验 V2
 */
// export function sendRiskSmsVerifyCode(
//   params: {
//     contextToken: string
//   },timeout: number) {
//   return post<IBaseRespone<ISendRiskSmsVerifyResponse>>('/api/tm/unified-login/v2/open/login/risk/sendRiskSmsVerifyCode', params, {
//     timeout: timeout
//   })
// }

/**
 *  平台风控校验 V2
 */
// export function checkRiskSmsVerifyCode(
//   params: {
//     code: string,
//     contextToken: string
//   }
// ) {
//   return post<IBaseRespone<ICheckRiskSmsVerifyCodeResponse>>('/api/tm/unified-login/v2/open/login/risk/checkRiskSmsVerifyCode', params)
// }



/**
 * 校验卖家账号是否重复
 */
export function checkTenantRepeat(params: {
  //卖家id
  tenantId: string
}) {
  return post<IBaseRespone<void>>('/open/tm/unified-login/v5/register/tenant/check', params)
}

/**
 * 用户注册
 */
export function userRegister(params: {
  //公司或店铺名称
  name: string,
  //卖家id
  tenantId: string,
  //卖家登录密码
  password: string,
  //卖家手机号
  mobile: string,
	// 验证码key
	authKey: string, 
  //手机验证码
  authCode: string,
  // 注册源
  registerSource: string,
  // 额外的传参
  customMetaData: any
}) {
  return post<IBaseRespone<string>>('/open/tm/unified-login/v5/tenant/register', params)
}

export function userRegisterEasy(params: {
  //公司或店铺名称
  name?: string,
  //卖家手机号
  mobile: string,
  //与verifyCode配对
  authKey: string,
  //手机验证码
  authCode: string,
  // 注册源
  registerSource: string,
  // 额外的传参
  customMetaData: any
}) {
  return post<IBaseRespone<string>>('/open/tm/unified-login/v5/tenant/register/easy', params)
}

/**
 * 注册发送短信验证码
 */
export function sendSMSVerifyCodeForRegister(params: {
  //图片验证码验证后返回的token
  captchaId: string,
  //手机号
  mobile: string,
	registerFrom: RegisterFrom
}) {
  return post<IBaseRespone<{authKey: string}>>('/open/tm/unified-login/v5/register/sendSMSVerifyCode', params)
}

export function productMap(params: {}) {
  return post<IBaseRespone<object>>('/api/tm/unified-login/v1/auth/employee/productMap', params)
}

export class EmployeeApi {
   /**
   * 当前登录账号密码修改
   */
  static getEmployeeList() {
    return post<IBaseRespone<{employeeId:number, nickname: string}[]>>('/api/tm/unified-login/v5/admin/employee/list', {})
  }

  /**
   * 当前登录账号密码修改
   */
  static modifySelfPassword(params: {
    //原始密码
    oldPassword?: string,
    //新密码
    newPassword: string
  }) {
    return post<IBaseRespone<object>>('/api/tm/unified-login/v5/admin/employee/modifySelfPassword', params)
  }

  /**
   * 分页查询员工列表
   */
  // static employeePageQuery(params: {
  //   //每页账号数目
  //   pageSize: number,
  //   //第几页员工
  //   pageNum: number,
  //   //查询员工时用，没有使用关键字查询时填null
  //   keyword?: string,
  //   //查询员工时用，没有使用权限查询时填null
  //   jurisdiction?: number,
  //   //查询没被删除的员工填 0，查询回收站员工填 1
  //   isDelete: number,
  // }, timeout: number) {
  //   return post<IBaseRespone<EmployeePageQueryResponse>>('/api/tm/unified-login/v1/auth/employee/page', params, {
  //     timeout: timeout
  //   })
  // }

  /**
   * 更新员工信息
   */
  // static employeeUpdate(params: {
  //   //待更新员工id
  //   employeeId: number,
  //   //编号
  //   number: string,
  //   //昵称
  //   nickName: string,
  //   //姓名
  //   name: string,
  //   //手机号
  //   mobile: string,
  //   //性别; 0男性 1女性
  //   sex: number,
  //   //雇佣时间
  //   employeeTime: string,
  //   //紧急联系人
  //   distressCall: string,
  //   //旺旺账号
  //   wangwangNumber: string,
  //   //QQ账号
  //   qqNumber: string,
  //   //邮箱
  //   email: string,
  //   //备注
  //   comment: string,
  //   //账号停用或启用；0启用 1停用
  //   status: number,
  //   //员工权限
  //   jurisdiction: number,
  //   //手机号是否修改
  //   isMobileChanged: boolean,
  //   //权限是否修改
  //   isJurisdictionChanged: boolean
  // }, timeout: number) {
  //   return post<IBaseRespone<string>>('/api/tm/unified-login/v1/auth/employee/update', params, {
  //     timeout: timeout
  //   })
  // }

  /**
   * 员工详细信息查询
   */
  // static employeeQuery(params: {
  //   //待查询员工id
  //   employeeId: number,
  //   //场景 0表示展示员工详情界面,手机号要加密 1表示修改员工详情界面,手机号不要加密
  //   state: number
  // }, timeout?: number) {
  //   return post<IBaseRespone<EmployeeDetail>>('/api/tm/unified-login/v1/auth/employee/query', params, {
  //     timeout: timeout
  //   })
  // }

  /**
   * 校验员工编号是否重复
   */
  static verifyMerchantNoDuplicate(params: {
		employeeId: number
    //员工编号
    employeeNo: string
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/employee/verifyNo', params)
  }

  /**
   * 校验员工昵称是否重复
   */
  static verifyNicknameDuplicate(params: {
		// 新建员工时传0
		employeeId: number,
    //员工昵称
    nickname: string
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/employee/verifyNickname', params)
  }

  /**
   * 校验员工昵称是否重复
   */
  static verifyMobileDuplicate(params: {
		// 新建员工时传0
		employeeId: number,

    //员工昵称
    mobile: string,
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/employee/verifyMobile', params)
  }

  /**
   * 创建员工
   */
  // static employeeCreate(params: {
  //   //编号
  //   number: string,
  //   //昵称
  //   nickName: string,
  //   //姓名
  //   name: string,
  //   //手机号
  //   mobile: string,
  //   //性别
  //   sex: number,
  //   //雇佣时间
  //   employmentDate: string,
  //   //紧急联系人
  //   distressCall: string,
  //   //旺旺账号
  //   wangwangNumber: string,
  //   //QQ账号
  //   qqNumber: string,
  //   //邮箱
  //   email: string,
  //   //备注
  //   comment: string,
  //   //账号停用或启用；0启用 1停用
  //   status: number,
  //   //员工权限
  //   jurisdiction: number,
  //   //是否同时创建账号
  //   createLoginAccount?: boolean,
  //   //登录账号密码
  //   password: string
  // },timeout: number) {
  //   return post<IBaseRespone<string>>('/api/tm/unified-login/v1/auth/employee/create', params,{
  //     timeout: timeout
  //   })
  // }

  /**
   * 删除或恢复员工
   */
  static deleteOrRestoreEmployee(params: {
    //待修改状态的员工id列表
    employeeIdList: number[],
    //删除或恢复员工标志位; 0表示恢复 1表示删除
    operation: number,
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/employee/updateStatus', params)
  }

  /**
   * 获取员工权限
   */
  // static employeeJurisdictionQuery() {
  //   return post<IBaseRespone<AccountMessage>>('/api/tm/unified-login/v1/auth/employee/jurisdiction/query', '')
  // }

  /**
   * 员工创建账号
   */
  static createAccount(params: {
    //待创建账号的员工id
    employeeId: number,
    //账号名
    account: string,
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/account/create', params)
  }

	static deleteAccount(params: {
    //账号名
    account: string
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/account/delete', params)
  }

  /**
   * 分页查询账号列表
   */
  // static accountPageQuery(params: {
  //   //待创建账号的员工id
  //   employeeId: number,
  //   //第几页账号
  //   pageNum: number,
  //   //每页账号数目
  //   pageSize: number
  // }) {
  //   return post<IBaseRespone<StaffAccountResponse>>('/api/tm/unified-login/v1/auth/account/page', params)
  // }

  /**
   * 修改员工账号密码
   */
  static passwordModify(params: {
    //待创建账号的员工id
    employeeId: number,
    //新密码
    newPassword: string
  }) {
    return post<IBaseRespone<void>>('/api/tm/unified-login/v5/admin/employee/modifyPassword', params)
  }



}

/**
 * 获取皮肤
 * @param params
 * @param timeout
 */
export function getSkin(params: {
  //登录页面来源
  src?: string | null,
  //产品线ID
  productId?: string | null,
  //租户id
  merchantId?: string | null
}, timeout: number) {
  return post<IBaseRespone<string>>('/open/tm/unified-login/v4/open/front/background', params, {
    timeout: timeout
  })
}
